import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface StatusCardWorkspaceState {
  item: any;
  detailPanel: any;
  items?: any[];
}

export interface StatusCardWorkspaceAction {
  type: string;
  payload?: any;
}

@Injectable({ providedIn: 'root' })
export class StatusCardWorkspaceService {
  private readonly channels = new Map<string, BehaviorSubject<StatusCardWorkspaceState | null>>();
  private readonly actionChannels = new Map<string, Subject<StatusCardWorkspaceAction>>();

  state$(source: string): Observable<StatusCardWorkspaceState | null> {
    return this.channel(source).asObservable();
  }

  publish(source: string, state: StatusCardWorkspaceState): void {
    if (source) this.channel(source).next(state);
  }

  actions$(source: string): Observable<StatusCardWorkspaceAction> {
    return this.actionChannel(source).asObservable();
  }

  dispatch(source: string, action: StatusCardWorkspaceAction): void {
    if (source) this.actionChannel(source).next(action);
  }

  private channel(source: string): BehaviorSubject<StatusCardWorkspaceState | null> {
    let channel = this.channels.get(source);
    if (!channel) {
      channel = new BehaviorSubject<StatusCardWorkspaceState | null>(null);
      this.channels.set(source, channel);
    }
    return channel;
  }

  private actionChannel(source: string): Subject<StatusCardWorkspaceAction> {
    let channel = this.actionChannels.get(source);
    if (!channel) {
      channel = new Subject<StatusCardWorkspaceAction>();
      this.actionChannels.set(source, channel);
    }
    return channel;
  }
}
